import React from "react";
import New_1 from "../../../assets/images/home_page_5/new-device/01.png";
import New_2 from "../../../assets/images/home_page_5/new-device/02.png";
import New_3 from "../../../assets/images/home_page_5/new-device/03.png";

const newDevices = [
    { id: 1, img: New_1, title: "New Device coming" },
    { id: 2, img: New_2, title: "New Device coming" },
    { id: 3, img: New_3, title: "New Device coming" },
];

const New = () => {
    return (
        <section id="new-device" className="new-device-main-block">
            <div className="container">
                <div className="row">
                    {newDevices.map((device) => (
                        <div key={device.id} className="col-lg-4 col-md-4">
                            <div className="new-device-block">
                                <h5 className="new-device-title text-center">{device.title}</h5>
                                <div className="new-device-img">
                                    <img src={device.img} className="img-fluid" alt={device.title} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default New;
